import { render, staticRenderFns } from "./upload-list-container.vue?vue&type=template&id=0397c052&scoped=true&"
import script from "./upload-list-container.vue?vue&type=script&lang=js&"
export * from "./upload-list-container.vue?vue&type=script&lang=js&"
import style0 from "./upload-list-container.vue?vue&type=style&index=0&id=0397c052&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0397c052",
  null
  
)

export default component.exports